export default __webpack_public_path__ + "ff0671fd0d94bd6b54c92fa8a9c2fc68.png";